import React, { useState } from 'react';
import styled from 'styled-components';
import { KitInputStyles } from './KitInput';
import constants from '../../common/theme/constants';
import { KitFormInfoText } from './KitFormControls';

const StyledTextArea = styled.textarea<{ focused: boolean; error?: boolean; disabled?: boolean }>`
  ...${KitInputStyles}
  height: 100px;
  padding-top: ${constants.spacing.absolute.sm}px;
`;

type Ref = HTMLTextAreaElement;
export interface KitTextAreaProps extends React.ComponentPropsWithRef<'textarea'> {
  isError?: boolean;
  className?: string;
  infoMessage?: string;
}

const KitTextArea = React.forwardRef<Ref, KitTextAreaProps>((props, ref) => {
  const { isError, infoMessage = null, onBlur, required, ...otherProps } = props;
  const [focused, setFocused] = useState(false);
  return (
    <>
      <StyledTextArea
        focused={focused}
        error={isError}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={(e) => {
          setFocused(false);
          if (typeof onBlur === 'function') {
            onBlur(e);
          }
        }}
        ref={ref}
        aria-required={required}
        required={required}
        aria-invalid={isError}
        {...otherProps}
      />
      {infoMessage && (
        <KitFormInfoText
          isError={isError}
          text={infoMessage}
          aria-label={infoMessage}
          aria-live='polite'
        />
      )}
    </>
  );
});

export default KitTextArea;
